/**
 * What one unit costs us: per receptionist conversation, per voice minute,
 * per Bailey question (by model). From the overview / salon API's
 * unitEconomics block.
 */
import React from 'react';
import { fmtPence, unitRows } from './aiFormat';

export default function UnitEconomics({ data, title = 'Unit economics' }) {
  const rows = unitRows(data);
  if (!rows.length) return null;
  return (
    <div className="fin-section">
      <div className="fin-section-header">
        <h3 className="fin-section-title">{title}</h3>
        <span className="fin-section-sub">Average cost to us, this month</span>
      </div>
      <table className="fin-table ai-ov-units">
        <thead><tr><th>Unit</th><th className="num">Avg cost</th><th>Basis</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className={r.sub ? 'ai-ov-sub' : ''}>
              <td>{r.label.trim()}</td>
              <td className="num">{fmtPence(r.avg)}</td>
              <td className="fin-dim">{r.detail}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
